import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=11f6c0b4&scoped=true&"
import script from "./Setup.vue?vue&type=script&lang=js&"
export * from "./Setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6c0b4",
  null
  
)

export default component.exports